import Container from 'react-bootstrap/Container';
import { useTranslation } from 'react-i18next';
import React, { Fragment } from 'react';
import Header from '../../components/Header';

const Completed = () => {
  const { t } = useTranslation('commons');
  return (
    <Fragment>
      <Header />
      <Container className="mt-4">
        <div className="shadow px-3 py-4 mb-5 bg-white">
          <h3 className="font-weight-bold">{t('surveyCompletedHeader')}</h3>
          <h5 className="mt-4">{t('surveyCompleted')}</h5>
        </div>
      </Container>
    </Fragment>
  );
}

export default Completed;
